import { Component, Input } from '@angular/core';

@Component({
    selector: 'sub-menu',
    templateUrl: './sub-menu.component.html'
})
export class SubMenuComponent {
    @Input() path: string;
}
